import Expander from '../Expander';
import AddressWithLink from '../PartnerDetails/AddressWithLink';

const StoreDetails = ({ stores }) => (
  <div className="store-container">
    <Expander
      summary="Store Information"
      details={
        <ul className="store-main-list">
          <li>
            {stores.map((store) => {
              const { id, fullAddress, lat, lng, contactInfo } = { ...store };
              const { phoneNumber } = {
                ...contactInfo,
              };
              return (
                <ul className="store-child-list" key={id}>
                  <li>{store.name}</li>
                  <li className="list-store-address">
                    <div className="store-icon" />
                    <div className="store-address">
                      <AddressWithLink address={fullAddress} lat={lat} lng={lng} />
                    </div>
                  </li>
                  {phoneNumber && (
                    <li className="list-store-contact">
                      <div className="call-icon" />
                      <span>
                        <a href={`tel: ${phoneNumber}`}>{`+65 ${phoneNumber}`}</a>
                      </span>
                    </li>
                  )}
                </ul>
              );
            })}
          </li>
        </ul>
      }
    />
  </div>
);

export default StoreDetails;
